import AemImage from '@/components/AemImage/AemImage';
import BadgeImage from '@/components/BadgeCard/BadgeImage';
import type {ImageModel} from '@/types/aem';

type BadgeDetailHeroProps = {
    imageUrl?: string;
    backgroundImage?: ImageModel[];
};

const overlay = 'pointer-events-none absolute inset-0';

/**
 * Hero visual for badge detail — full-bleed background image with three
 * decorative gradient overlays and the badge artwork centered on top.
 *
 * The gradient hex values are one-off decorative stops from the design spec
 * and intentionally not tokenized.
 */
const BadgeDetailHero = ({imageUrl, backgroundImage}: BadgeDetailHeroProps) => (
    <>
        <AemImage imageMedia={backgroundImage} imgClassName='absolute inset-0 h-full w-full object-cover' />

        {/* Primary depth gradient — top-to-bottom fade */}
        <div
            className={`${overlay} bg-[linear-gradient(180deg,#3A3F42_0.45%,transparent_45%,rgba(58,63,66,0.9)_77.5%,rgba(44,44,44,0.9)_100%)]`}
            aria-hidden
        />

        {/* Conic highlight — soft-light blend for subtle color accent */}
        <div
            className={`${overlay} bg-[conic-gradient(from_125.22deg_at_47.87%_63.15%,transparent_0deg,var(--color-graphite)_151.2deg,#5ECED0_223.2deg,var(--color-graphite)_297deg,transparent_360deg)] mix-blend-soft-light`}
            aria-hidden
        />

        {/* Radial vignette */}
        <div
            className={`${overlay} bg-[radial-gradient(87.03%_87.03%_at_50%_50%,transparent_0%,rgba(0,0,0,0.6)_100%)]`}
            aria-hidden
        />

        <div className='absolute inset-0 flex items-center justify-center'>
            <BadgeImage imageUrl={imageUrl} size={315} fetchSize={512} />
        </div>
    </>
);

export default BadgeDetailHero;
